'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconHashtag, iconHashtagTag } from '@ni/nimble-components/dist/esm/icons/hashtag';
import { wrap } from '../../utilities/react-wrapper';

export type { IconHashtag };
export { iconHashtagTag };
export const NimbleIconHashtag = wrap(IconHashtag);